import HeaderChart from './HeaderChart';

export default HeaderChart;
